export const es = {
  app: {
    title: 'Lex Suite',
    subtitle: 'para Office',
  },
  auth: {
    login: 'Iniciar sesión',
    loginCta: 'Conectar con Lex Suite',
    loginHint:
      'Inicia sesión con tu cuenta del estudio para acceder a documentos, plantillas y firmas.',
    previewHint:
      'Estás viendo el complemento en el navegador. Para usarlo, instalalo en Word o Excel desde Settings → Lex Suite para Office.',
    logout: 'Cerrar sesión',
    studio: 'Estudio',
    selectStudio: 'Selecciona un estudio',
  },
  home: {
    documents: 'Documentos',
    documentsDesc: 'Buscar y abrir archivos del estudio',
    templates: 'Plantillas de contratos',
    templatesDesc: 'Insertar plantillas con cláusulas',
    clauses: 'Biblioteca de cláusulas',
    clausesDesc: 'Insertar cláusulas por jurisdicción',
    save: 'Guardar en Lex',
    saveDesc: 'Subir versión nueva al expediente',
    sign: 'Firmar',
    signDesc: 'Enviar a circuito de firma',
    workflow: 'Workflow',
    workflowDesc: 'Disparar workflow del expediente',
    settings: 'Configuración',
  },
  documents: {
    search: 'Buscar documentos…',
    open: 'Abrir',
    empty: 'No se encontraron documentos.',
  },
  templates: {
    insert: 'Insertar',
    empty: 'No hay plantillas disponibles.',
  },
  clauses: {
    jurisdiction: 'Jurisdicción',
    insert: 'Insertar',
    empty: 'No hay cláusulas disponibles.',
  },
  save: {
    cta: 'Guardar como nueva versión',
    success: 'Documento guardado en Lex Suite',
    error: 'No se pudo guardar el documento',
  },
  common: {
    loading: 'Cargando…',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Volver',
    error: 'Ocurrió un error',
    retry: 'Reintentar',
  },
  settings: {
    language: 'Idioma',
    spanish: 'Español',
    english: 'Inglés',
    profile: 'Perfil',
  },
};
